//```import constants types
import {
  VIDFLEET_CONFIGURATION_HUBSPOT_LOAD,
  VIDFLEET_CONFIGURATION_HUBSPOT_LOAD_RESULT,
  VIDFLEET_CONFIGURATION_HUBSPOT_SAVE,
  VIDFLEET_CONFIGURATION_HUBSPOT_SAVE_RESULT,
  VIDFLEET_CONFIGURATION_HUBSPOT_HIDE
} from 'Redux/actionTypes';


export const vidfleetConfigurationHubSpotLoadData = (esn, devices, mode) => ({
  type: VIDFLEET_CONFIGURATION_HUBSPOT_LOAD,
  payload: { esn: esn, devices: devices, mode: mode }
});

export const vidfleetConfigurationHubSpotLoadDataResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_HUBSPOT_LOAD_RESULT,
  payload: data
});

export const vidfleetConfigurationHubSpotSave = (config, esns, deviceIds, oldConfig, applyScopes, verificationCode) => ({
  type: VIDFLEET_CONFIGURATION_HUBSPOT_SAVE,
  payload: { config: config, esns: esns, deviceIds: deviceIds, oldConfig: oldConfig, applyScopes: applyScopes, verificationCode: verificationCode }
});

export const vidfleetConfigurationHubSpotSaveResult = (data) => ({
  type: VIDFLEET_CONFIGURATION_HUBSPOT_SAVE_RESULT,
  payload: data
});

export const vidfleetConfigurationHubSpotHide = () => ({
  type: VIDFLEET_CONFIGURATION_HUBSPOT_HIDE,
  //payload: accounts
});
